import { Link } from 'react-router-dom';

const columns = [
  {
    title: '内容栏目',
    links: [
      { label: '娱乐新闻', to: '/news' },
      { label: '影视推荐', to: '/movies' },
      { label: '热门话题', to: '/hot-topics' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '网站定位', to: '/about' },
      { label: '联系方式', to: '/about' },
    ],
  },
];

const socials = [
  { icon: 'ri-weibo-fill', label: '微博' },
  { icon: 'ri-wechat-fill', label: '微信' },
  { icon: 'ri-tiktok-fill', label: '抖音' },
  { icon: 'ri-bilibili-fill', label: '哔哩哔哩' },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-logo text-3xl text-primary-600">靠逼</span>
              <span className="text-sm font-semibold tracking-wide text-foreground-700">娱乐资讯</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              靠逼是一个综合性的娱乐资讯平台，汇聚最新娱乐新闻、影视推荐与热门话题，
              为热爱娱乐动态的你提供及时、丰富、多元的内容，让每一次浏览都值得。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  aria-label={s.label}
                  title={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-lg`} />
                </button>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label + link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 靠逼 · 综合娱乐资讯站 · 内容仅为示范展示</p>
          <p className="flex items-center gap-2">
            <i className="ri-information-line" />
            本站资讯均为虚拟示范内容，不代表任何真实事件
          </p>
        </div>
      </div>
    </footer>
  );
}